import React from 'react';
import { Container, Box, Typography, Divider } from '@mui/material';

/**
 * ページレイアウトの共通コンポーネント
 * @param {Object} props - コンポーネントのプロパティ
 * @param {string} props.title - ページのタイトル
 * @param {string} props.maxWidth - Containerの最大幅（'xs', 'sm', 'md', 'lg', 'xl'）
 * @param {React.ReactNode} props.children - レイアウト内に表示するコンテンツ
 * @param {React.ReactNode} props.titleActions - タイトルの横に表示するアクション要素
 * @param {Object} props.containerSx - Containerの追加スタイル
 * @param {Object} props.boxSX - Paperの追加スタイル
 * @param {Object} props.titleSx - タイトルの追加スタイル
 * @param {Object} props.dividerSx - Dividerの追加スタイル
 */
const UserPageLayout = ({
  title,
  maxWidth = 'sm',
  children,
  titleActions,
  containerSx = {},
  boxSX = {},
  titleSx = {},
  dividerSx = {},
}) => {
  return (
    <Container
      component="main"
      maxWidth={maxWidth}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        py: '5vh',
        backgroundColor: 'white',
        ...containerSx,
      }}
    >
      <Box
        sx={{
          marginBottom: '2vh',
          minHeight: '100vh',
          ...boxSX,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            margin: 1,
            flexWrap: 'wrap',
            gap: 1,
          }}
        >
          <Typography
            variant="h3"
            sx={{
              flex: 1,
              minWidth: 'fit-content',
              fontWeight: 'bold',
              ...titleSx,
            }}
          >
            {title}
          </Typography>
          {titleActions && <Box sx={{ flexShrink: 0 }}>{titleActions}</Box>}
        </Box>

        <Divider
          sx={{
            width: '100%',
            borderColor: '#32c86b',
            borderBottomWidth: 3,
            mb: 2,
            ...dividerSx,
          }}
        />

        {children}
      </Box>
    </Container>
  );
};

export default UserPageLayout;
